import { render } from "./InfoCapital.vue?vue&type=template&id=69ec4122&scoped=true"
import script from "./InfoCapital.vue?vue&type=script&lang=js"
export * from "./InfoCapital.vue?vue&type=script&lang=js"

import "./InfoCapital.vue?vue&type=style&index=0&id=69ec4122&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ec4122"]])

export default __exports__